import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload() {
    // Generate procedural vector textures directly into Phaser Texture Manager
    this.createProceduralTextures();
  }

  create() {
    this.scene.start('MainScene');
  }

  createProceduralTextures() {
    // 1. Soft Particle / Glow Star
    const starGfx = this.make.graphics({ x: 0, y: 0, add: false });
    starGfx.fillStyle(0xFFFFFF, 1);
    starGfx.fillCircle(16, 16, 12);
    starGfx.generateTexture('particle_star', 32, 32);
    starGfx.destroy();

    // 2. Heart Texture
    const heartGfx = this.make.graphics({ x: 0, y: 0, add: false });
    heartGfx.fillStyle(0xFF4081, 1);
    heartGfx.fillCircle(10, 10, 8);
    heartGfx.fillCircle(22, 10, 8);
    heartGfx.fillTriangle(2, 12, 30, 12, 16, 28);
    heartGfx.generateTexture('particle_heart', 32, 32);
    heartGfx.destroy();

    // 3. Teardrop Texture (for Sad state)
    const dropGfx = this.make.graphics({ x: 0, y: 0, add: false });
    dropGfx.fillStyle(0x40C4FF, 0.9);
    dropGfx.fillCircle(12, 18, 8);
    dropGfx.fillTriangle(4, 18, 20, 18, 12, 4);
    dropGfx.generateTexture('particle_tear', 24, 28);
    dropGfx.destroy();

    // 4. Fire / Steam Puff Texture (for Mad state)
    const fireGfx = this.make.graphics({ x: 0, y: 0, add: false });
    fireGfx.fillStyle(0xFF5252, 0.9);
    fireGfx.fillCircle(16, 16, 14);
    fireGfx.fillStyle(0xFFD700, 0.8);
    fireGfx.fillCircle(16, 16, 8);
    fireGfx.generateTexture('particle_fire', 32, 32);
    fireGfx.destroy();

    // 5. Cloud Texture (for Sleep mini-game)
    const cloudGfx = this.make.graphics({ x: 0, y: 0, add: false });
    cloudGfx.fillStyle(0xFFFFFF, 0.95);
    cloudGfx.fillCircle(24, 28, 18);
    cloudGfx.fillCircle(45, 20, 22);
    cloudGfx.fillCircle(68, 28, 18);
    cloudGfx.fillRoundedRect(10, 22, 72, 22, 10);
    cloudGfx.generateTexture('cloud_plat', 92, 50);
    cloudGfx.destroy();

    // 6. Food Items (Burger, Donut, Apple, Bomb)
    // Apple
    const appleGfx = this.make.graphics({ x: 0, y: 0, add: false });
    appleGfx.fillStyle(0xFF3B30, 1);
    appleGfx.fillCircle(20, 24, 16);
    appleGfx.fillStyle(0x4CD964, 1);
    appleGfx.fillTriangle(18, 8, 26, 4, 22, 12);
    appleGfx.generateTexture('food_apple', 40, 44);
    appleGfx.destroy();

    // Donut
    const donutGfx = this.make.graphics({ x: 0, y: 0, add: false });
    donutGfx.fillStyle(0xF39C12, 1);
    donutGfx.fillCircle(22, 22, 18);
    donutGfx.fillStyle(0xFF69B4, 1);
    donutGfx.fillCircle(22, 20, 14);
    donutGfx.fillStyle(0x1a1d36, 1);
    donutGfx.fillCircle(22, 20, 6);
    donutGfx.generateTexture('food_donut', 44, 44);
    donutGfx.destroy();

    // Burger
    const burgerGfx = this.make.graphics({ x: 0, y: 0, add: false });
    burgerGfx.fillStyle(0xE67E22, 1); // Bun top
    burgerGfx.fillRoundedRect(6, 6, 32, 12, 6);
    burgerGfx.fillStyle(0x27AE60, 1); // Lettuce
    burgerGfx.fillRect(4, 16, 36, 4);
    burgerGfx.fillStyle(0x8E44AD, 0); 
    burgerGfx.fillStyle(0x795548, 1); // Patty
    burgerGfx.fillRect(6, 20, 32, 6);
    burgerGfx.fillStyle(0xE67E22, 1); // Bun bottom
    burgerGfx.fillRoundedRect(6, 26, 32, 8, 4);
    burgerGfx.generateTexture('food_burger', 44, 40);
    burgerGfx.destroy();

    // Bomb / Hazard
    const bombGfx = this.make.graphics({ x: 0, y: 0, add: false });
    bombGfx.fillStyle(0x2C3E50, 1);
    bombGfx.fillCircle(20, 24, 15);
    bombGfx.fillStyle(0xE74C3C, 1);
    bombGfx.fillCircle(20, 8, 5);
    bombGfx.generateTexture('hazard_bomb', 40, 44);
    bombGfx.destroy();

    // 7. Catcher Basket / Plate
    const trayGfx = this.make.graphics({ x: 0, y: 0, add: false });
    trayGfx.fillStyle(0x6C5CE7, 1);
    trayGfx.fillRoundedRect(0, 8, 80, 16, 8);
    trayGfx.fillStyle(0xA29BFE, 1);
    trayGfx.fillRoundedRect(6, 2, 68, 8, 4);
    trayGfx.generateTexture('catcher_tray', 80, 26);
    trayGfx.destroy();

    // 8. Hurdle Texture
    const hurdleGfx = this.make.graphics({ x: 0, y: 0, add: false });
    hurdleGfx.fillStyle(0xFF5252, 1);
    hurdleGfx.fillRect(4, 0, 8, 40);
    hurdleGfx.fillRect(28, 0, 8, 40);
    hurdleGfx.fillStyle(0xFFFFFF, 1);
    hurdleGfx.fillRect(0, 6, 40, 10);
    hurdleGfx.generateTexture('hurdle_bar', 40, 40);
    hurdleGfx.destroy();
  }
}
